var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditpencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54 19.0201C2.93 19.0201 2.36 18.81 1.95 18.42C1.43 17.93 1.18 17.19 1.27 16.39L1.64 13.15C1.71 12.54 2.08 11.73 2.51 11.29L10.72 2.60005C12.77 0.430049 14.91 0.370049 17.08 2.42005C19.25 4.47005 19.31 6.61005 17.26 8.78005L9.05 17.47C8.63 17.92 7.85 18.34 7.24 18.4401L4.02 18.99C3.85 19 3.7 19.0201 3.54 19.0201ZM13.93 2.41005C13.16 2.41005 12.49 2.89005 11.81 3.61005L3.6 12.3101C3.4 12.5201 3.17 13.0201 3.13 13.3101L2.76 16.55C2.72 16.88 2.8 17.15 2.98 17.32C3.16 17.49 3.43 17.55 3.76 17.5L6.98 16.9501C7.27 16.9001 7.75 16.64 7.95 16.43L16.16 7.74005C17.4 6.42005 17.85 5.20005 16.04 3.50005C15.24 2.73005 14.55 2.41005 13.93 2.41005Z",
    fill: "#7E92A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.34 10.45C15.32 10.45 15.29 10.45 15.27 10.45C12.15 10.14 9.64 7.77005 9.16 4.67005C9.1 4.26005 9.38 3.88005 9.79 3.81005C10.2 3.75005 10.58 4.03005 10.65 4.44005C11.03 6.86005 12.99 8.72005 15.43 8.96005C15.84 9.00005 16.14 9.37005 16.1 9.78005C16.05 10.16 15.72 10.45 15.34 10.45Z",
    fill: "#7E92A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 22.25H1C0.59 22.25 0.25 21.91 0.25 21.5C0.25 21.09 0.59 20.75 1 20.75H19C19.41 20.75 19.75 21.09 19.75 21.5C19.75 21.91 19.41 22.25 19 22.25Z",
    fill: "#7E92A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpencil);
export default __webpack_public_path__ + "static/media/editpencil.c552ddb52a960b3bed7ada599371f707.svg";
export { ForwardRef as ReactComponent };